import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { setRecipeCookie, getRecipeCookie } from 'lib/Cookies/recipe';
import getConfig from 'next/config';
import { Star } from './Star';

const uuid = require('uuid');

export function Ratings(props) {
  const { ratingCount, ratingValue, viewerRating = 0 } = props;

  const [activeHoverStart, setActiveHoverStar] = useState(null);
  const [stateViewerRating, setStateViewerRating] = useState(viewerRating);
  const [stateRatingCount, setStateRatingCount] = useState(ratingCount);

  const ratingVal = parseFloat(ratingValue);
  const ratingKey = stateViewerRating > 0 ? 'YOUR RATING' : 'RATE THIS RECIPE';

  const saveRating = async (rating) => {
    const { id: recipeID, ratingID } = props;
    const { publicRuntimeConfig: { STAR_RATER_URL } } = getConfig();

    setStateViewerRating(rating);

    // if cookie isn't set for this recipe, it is a new rating
    // otherwise, it is a recipe rating change

    const lastRating = getRecipeCookie(recipeID) || 0;
    if (lastRating && lastRating === rating) {
      return;
    }

    setRecipeCookie(recipeID, rating);

    // update the rating count in front
    if (lastRating === 0) {
      setStateRatingCount(ratingCount + 1);
    }

    await fetch(`${STAR_RATER_URL}/ratings`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        clientName: 'today',
        lastRating,
        rating,
        ratingID,
        requestID: uuid.v4(),
        recipeID,
      }),
    })
      .then((response) => response.json());
  };

  return (
    <div className="rating__container dn-print">
      <div className="stars__key">{ratingKey}</div>
      <div className="stars__container" data-test="rating">
        <div id="rating__stars" className="rating__stars" data-test="rating_stars">
          {[0, 1, 2, 3, 4].map((ratingPoint) => (
            <Star
              key={ratingPoint}
              viewerRating={stateViewerRating}
              ratingPoint={ratingPoint + 1}
              ratingValue={ratingVal}
              remainder={(ratingVal - ratingPoint) % 5}
              activeHoverStart={activeHoverStart}
              onHover={setActiveHoverStar}
              onClick={saveRating}
            />
          ))}
        </div>
        <div className="rating__count" data-test="rating_count">
          (
          {stateRatingCount}
          )
        </div>
      </div>
    </div>
  );
}

Ratings.propTypes = {
  ratingID: PropTypes.string,
  ratingCount: PropTypes.number,
  ratingValue: PropTypes.number,
  viewerRating: PropTypes.number,
  id: PropTypes.string.isRequired,
};

Ratings.defaultProps = {
  ratingID: '',
  ratingCount: 0,
  ratingValue: 0,
  viewerRating: 0,
};

export default Ratings;
